exports.ENTITY_PLATFORMS = {
    ccms: 'ccms',
    default: 'ccms',
    salesforce: 'salesforce',
};



// WEBPACK FOOTER //
// ./src/constants/entityPlatforms.js